<template>
  <div class="icon-wrapper">
    <svg
      class="icon circle-icon"
      :style="getStyle"
      :width="width"
      :height="height"
    >
      <use v-bind="{ 'xlink:href': '/feather-sprite.svg#' + name }"></use>
    </svg>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    width: {
      type: [Number, String],
      default: 30,
    },
    height: {
      type: [Number, String],
      default: 30,
    },
    padding: {
      type: [Number, String],
      default: 10,
    },
  },
  computed: {
    getStyle() {
      return "padding: " + this.padding + "px";
    },
  },
};
</script>

<style scoped>
.icon-wrapper {
  display: inline-flex;
  align-items: center;
  color: #282c5a;
  font-size: 1rem;
  font-weight: 600;
}

.icon {
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
  color: #282c5a;
}

.circle-icon {
  background: #ffffff;
  border-radius: 50%;
}
</style>
